import { WSQueryConfig } from "@ws-react-query";
import { getWorkLogConfig } from "../../../services/workLogConfig";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { QUERY_WORK_LOG_CONFIG } from "../keys";

export const useQueryWorkLogConfig = (
  config?: WSQueryConfig<
    Awaited<ReturnType<typeof getWorkLogConfig>>,
    WSServiceError
  >
) => useWSQuery([QUERY_WORK_LOG_CONFIG], () => getWorkLogConfig(), config);
